document.addEventListener("DOMContentLoaded", function () {
  const inputElement = document.getElementById("flooring_price_INPUT_18");
  const wastageElement = document.getElementById("wastage");
  const totalSection = document.getElementById("flooring_price_DIV_26");
  const totalSectionMobile = document.getElementById("flooring_price_DIV_26_A");
  const quantitySection = document.getElementById("flooring_price_DIV_30");
  const addToCartInput = document.getElementById("flooring-quantity");
  const wastageCheckbox = document.getElementById("toggle_wastage");

  // This calculator isn't rendered on every product template
  if (
    !inputElement || !wastageCheckbox || !wastageElement || !totalSection ||
    !quantitySection || !addToCartInput ||
    typeof pack_size === "undefined" || typeof pack_price_discounted === "undefined" ||
    typeof floor_style === "undefined"
  ) {
    return;
  }

  function updateTotals() {
    const area = parseFloat(inputElement.value) || 0;
    const includeWastage = wastageCheckbox.checked;

    const result = calculateFlooring(area, pack_size, includeWastage, floor_style);

    const numberOfPacks = result.packsNeeded;
    const totalMeters = result.totalMeters.toFixed(2);
    const wastage = result.wastage.toFixed(2);

    // Update packs required
    quantitySection.innerHTML = `${numberOfPacks} (${totalMeters} <sup>m<sup>2</sup></sup>)`;

    // Update total price
    const totalPrice = ((numberOfPacks * pack_price_discounted)/100).toFixed(2);
    totalSection.innerHTML = Number(totalPrice).toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    if (totalSectionMobile) {
      totalSectionMobile.innerHTML = totalSection.innerHTML;
    }

    // Update wastage
    wastageElement.textContent = `Your wastage is: ${wastage} m²`;

    // Update hidden add-to-cart input
    addToCartInput.value = numberOfPacks;
  }

  inputElement.addEventListener("input", updateTotals);
  wastageCheckbox.addEventListener("change", updateTotals);

  // Initialize on page load
  updateTotals();
});

function calculateFlooring(areaM2, packSizeM2) {
  const includeWastage = document.getElementById('toggle_wastage').checked;

  let wastagePercent = 0;
  if (floor_style === "Straight" || floor_style === "Tile Effect") {
    wastagePercent = 0.10;
  } else if (floor_style === "Herringbone" || floor_style === "Chevron") {
    wastagePercent = 0.15;
  }

  // Only adjust area if wastage is included
  let adjustedAreaM2 = includeWastage ? areaM2 * (1 + wastagePercent) : areaM2;

 let formattedAjdustedArea = (adjustedAreaM2 / packSizeM2).toFixed(2);

  const packsNeeded = Math.ceil(formattedAjdustedArea);
  const totalMeters = packsNeeded * packSizeM2;
  const wastage = includeWastage ? adjustedAreaM2 - areaM2 : 0;
  return {
    packsNeeded,
    totalMeters: parseFloat(totalMeters),
    wastage: parseFloat(wastage.toFixed(2))
  };
}
